import CryptoJS, { AES } from "crypto-js";


export function AesCrypto(value: string) {
   return AES.encrypt(value, 'DwzyLZcNVu1XvtVX').toString();
}

export function AesDecrypt(value: string) {
    return AES.decrypt(value, 'DwzyLZcNVu1XvtVX').toString(CryptoJS.enc.Utf8) === 'true';
}